// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AcceptRa } from "./accept-ra";

/**
 * A bond (NIC teaming) over two or more NicConfig ids.
 */
export class BondConfig implements flatbuffers.IUnpackableObject<BondConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BondConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBondConfig(bb: flatbuffers.ByteBuffer, obj?: BondConfig): BondConfig {
    return (obj || new BondConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBondConfig(bb: flatbuffers.ByteBuffer, obj?: BondConfig): BondConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BondConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(): string | null;
  id(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  id(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * NicConfig ids enslaved by this bond.
   */
  members(index: number): string;
  members(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  members(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  membersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * 802.3ad, active-backup, balance-rr, …
   */
  mode(): string | null;
  mode(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  mode(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  lacpRate(): string | null;
  lacpRate(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  lacpRate(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  hashPolicy(): string | null;
  hashPolicy(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  hashPolicy(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  miiInterval(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  upDelay(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  downDelay(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  minLinks(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  primary(): string | null;
  primary(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  primary(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  dhcp4(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  dhcp6(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  acceptRa(): AcceptRa {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : AcceptRa.UNSET;
  }

  addresses(index: number): string;
  addresses(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  addresses(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  addressesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  gateway4(): string | null;
  gateway4(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  gateway4(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  gateway6(): string | null;
  gateway6(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  gateway6(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  mtu(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startBondConfig(builder: flatbuffers.Builder) {
    builder.startObject(17);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addMembers(builder: flatbuffers.Builder, membersOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, membersOffset, 0);
  }

  static createMembersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMembersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMode(builder: flatbuffers.Builder, modeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, modeOffset, 0);
  }

  static addLacpRate(builder: flatbuffers.Builder, lacpRateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, lacpRateOffset, 0);
  }

  static addHashPolicy(builder: flatbuffers.Builder, hashPolicyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, hashPolicyOffset, 0);
  }

  static addMiiInterval(builder: flatbuffers.Builder, miiInterval: number) {
    builder.addFieldInt32(5, miiInterval, 0);
  }

  static addUpDelay(builder: flatbuffers.Builder, upDelay: number) {
    builder.addFieldInt32(6, upDelay, 0);
  }

  static addDownDelay(builder: flatbuffers.Builder, downDelay: number) {
    builder.addFieldInt32(7, downDelay, 0);
  }

  static addMinLinks(builder: flatbuffers.Builder, minLinks: number) {
    builder.addFieldInt32(8, minLinks, 0);
  }

  static addPrimary(builder: flatbuffers.Builder, primaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, primaryOffset, 0);
  }

  static addDhcp4(builder: flatbuffers.Builder, dhcp4: boolean) {
    builder.addFieldInt8(10, +dhcp4, +false);
  }

  static addDhcp6(builder: flatbuffers.Builder, dhcp6: boolean) {
    builder.addFieldInt8(11, +dhcp6, +false);
  }

  static addAcceptRa(builder: flatbuffers.Builder, acceptRa: AcceptRa) {
    builder.addFieldInt8(12, acceptRa, AcceptRa.UNSET);
  }

  static addAddresses(builder: flatbuffers.Builder, addressesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, addressesOffset, 0);
  }

  static createAddressesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startAddressesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addGateway4(builder: flatbuffers.Builder, gateway4Offset: flatbuffers.Offset) {
    builder.addFieldOffset(14, gateway4Offset, 0);
  }

  static addGateway6(builder: flatbuffers.Builder, gateway6Offset: flatbuffers.Offset) {
    builder.addFieldOffset(15, gateway6Offset, 0);
  }

  static addMtu(builder: flatbuffers.Builder, mtu: number) {
    builder.addFieldInt32(16, mtu, 0);
  }

  static endBondConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createBondConfig(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    membersOffset: flatbuffers.Offset,
    modeOffset: flatbuffers.Offset,
    lacpRateOffset: flatbuffers.Offset,
    hashPolicyOffset: flatbuffers.Offset,
    miiInterval: number,
    upDelay: number,
    downDelay: number,
    minLinks: number,
    primaryOffset: flatbuffers.Offset,
    dhcp4: boolean,
    dhcp6: boolean,
    acceptRa: AcceptRa,
    addressesOffset: flatbuffers.Offset,
    gateway4Offset: flatbuffers.Offset,
    gateway6Offset: flatbuffers.Offset,
    mtu: number,
  ): flatbuffers.Offset {
    BondConfig.startBondConfig(builder);
    BondConfig.addId(builder, idOffset);
    BondConfig.addMembers(builder, membersOffset);
    BondConfig.addMode(builder, modeOffset);
    BondConfig.addLacpRate(builder, lacpRateOffset);
    BondConfig.addHashPolicy(builder, hashPolicyOffset);
    BondConfig.addMiiInterval(builder, miiInterval);
    BondConfig.addUpDelay(builder, upDelay);
    BondConfig.addDownDelay(builder, downDelay);
    BondConfig.addMinLinks(builder, minLinks);
    BondConfig.addPrimary(builder, primaryOffset);
    BondConfig.addDhcp4(builder, dhcp4);
    BondConfig.addDhcp6(builder, dhcp6);
    BondConfig.addAcceptRa(builder, acceptRa);
    BondConfig.addAddresses(builder, addressesOffset);
    BondConfig.addGateway4(builder, gateway4Offset);
    BondConfig.addGateway6(builder, gateway6Offset);
    BondConfig.addMtu(builder, mtu);
    return BondConfig.endBondConfig(builder);
  }

  unpack(): BondConfigT {
    return new BondConfigT(
      this.id(),
      this.bb!.createScalarList<string>(this.members.bind(this), this.membersLength()),
      this.mode(),
      this.lacpRate(),
      this.hashPolicy(),
      this.miiInterval(),
      this.upDelay(),
      this.downDelay(),
      this.minLinks(),
      this.primary(),
      this.dhcp4(),
      this.dhcp6(),
      this.acceptRa(),
      this.bb!.createScalarList<string>(this.addresses.bind(this), this.addressesLength()),
      this.gateway4(),
      this.gateway6(),
      this.mtu(),
    );
  }

  unpackTo(_o: BondConfigT): void {
    _o.id = this.id();
    _o.members = this.bb!.createScalarList<string>(this.members.bind(this), this.membersLength());
    _o.mode = this.mode();
    _o.lacpRate = this.lacpRate();
    _o.hashPolicy = this.hashPolicy();
    _o.miiInterval = this.miiInterval();
    _o.upDelay = this.upDelay();
    _o.downDelay = this.downDelay();
    _o.minLinks = this.minLinks();
    _o.primary = this.primary();
    _o.dhcp4 = this.dhcp4();
    _o.dhcp6 = this.dhcp6();
    _o.acceptRa = this.acceptRa();
    _o.addresses = this.bb!.createScalarList<string>(
      this.addresses.bind(this),
      this.addressesLength(),
    );
    _o.gateway4 = this.gateway4();
    _o.gateway6 = this.gateway6();
    _o.mtu = this.mtu();
  }

  unpackFields(...fields: string[]): BondConfigT {
    const t = new BondConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id();
    }
    if (fieldSet.has("members")) {
      t.members = this.bb!.createScalarList<string>(this.members.bind(this), this.membersLength());
    }
    if (fieldSet.has("mode")) {
      t.mode = this.mode();
    }
    if (fieldSet.has("lacp_rate")) {
      t.lacpRate = this.lacpRate();
    }
    if (fieldSet.has("hash_policy")) {
      t.hashPolicy = this.hashPolicy();
    }
    if (fieldSet.has("mii_interval")) {
      t.miiInterval = this.miiInterval();
    }
    if (fieldSet.has("up_delay")) {
      t.upDelay = this.upDelay();
    }
    if (fieldSet.has("down_delay")) {
      t.downDelay = this.downDelay();
    }
    if (fieldSet.has("min_links")) {
      t.minLinks = this.minLinks();
    }
    if (fieldSet.has("primary")) {
      t.primary = this.primary();
    }
    if (fieldSet.has("dhcp4")) {
      t.dhcp4 = this.dhcp4();
    }
    if (fieldSet.has("dhcp6")) {
      t.dhcp6 = this.dhcp6();
    }
    if (fieldSet.has("accept_ra")) {
      t.acceptRa = this.acceptRa();
    }
    if (fieldSet.has("addresses")) {
      t.addresses = this.bb!.createScalarList<string>(
        this.addresses.bind(this),
        this.addressesLength(),
      );
    }
    if (fieldSet.has("gateway4")) {
      t.gateway4 = this.gateway4();
    }
    if (fieldSet.has("gateway6")) {
      t.gateway6 = this.gateway6();
    }
    if (fieldSet.has("mtu")) {
      t.mtu = this.mtu();
    }
    return t;
  }
}

export class BondConfigT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: string | Uint8Array | null = null,
    public members: string[] = [],
    public mode: string | Uint8Array | null = null,
    public lacpRate: string | Uint8Array | null = null,
    public hashPolicy: string | Uint8Array | null = null,
    public miiInterval: number = 0,
    public upDelay: number = 0,
    public downDelay: number = 0,
    public minLinks: number = 0,
    public primary: string | Uint8Array | null = null,
    public dhcp4: boolean = false,
    public dhcp6: boolean = false,
    public acceptRa: AcceptRa = AcceptRa.UNSET,
    public addresses: string[] = [],
    public gateway4: string | Uint8Array | null = null,
    public gateway6: string | Uint8Array | null = null,
    public mtu: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? builder.createString(this.id!) : 0;
    const members = BondConfig.createMembersVector(
      builder,
      builder.createObjectOffsetList(this.members),
    );
    const mode = this.mode !== null ? builder.createString(this.mode!) : 0;
    const lacpRate = this.lacpRate !== null ? builder.createString(this.lacpRate!) : 0;
    const hashPolicy = this.hashPolicy !== null ? builder.createString(this.hashPolicy!) : 0;
    const primary = this.primary !== null ? builder.createString(this.primary!) : 0;
    const addresses = BondConfig.createAddressesVector(
      builder,
      builder.createObjectOffsetList(this.addresses),
    );
    const gateway4 = this.gateway4 !== null ? builder.createString(this.gateway4!) : 0;
    const gateway6 = this.gateway6 !== null ? builder.createString(this.gateway6!) : 0;

    return BondConfig.createBondConfig(
      builder,
      id,
      members,
      mode,
      lacpRate,
      hashPolicy,
      this.miiInterval,
      this.upDelay,
      this.downDelay,
      this.minLinks,
      primary,
      this.dhcp4,
      this.dhcp6,
      this.acceptRa,
      addresses,
      gateway4,
      gateway6,
      this.mtu,
    );
  }

  clone(): BondConfigT {
    const obj = new BondConfigT();
    obj.id = this.id;
    obj.members = [...this.members];
    obj.mode = this.mode;
    obj.lacpRate = this.lacpRate;
    obj.hashPolicy = this.hashPolicy;
    obj.miiInterval = this.miiInterval;
    obj.upDelay = this.upDelay;
    obj.downDelay = this.downDelay;
    obj.minLinks = this.minLinks;
    obj.primary = this.primary;
    obj.dhcp4 = this.dhcp4;
    obj.dhcp6 = this.dhcp6;
    obj.acceptRa = this.acceptRa;
    obj.addresses = [...this.addresses];
    obj.gateway4 = this.gateway4;
    obj.gateway6 = this.gateway6;
    obj.mtu = this.mtu;
    return obj;
  }

  equals(other: BondConfigT): boolean {
    if (this.id !== other.id) return false;
    if (this.members.length !== other.members.length) return false;
    for (let i = 0; i < this.members.length; i++) {
      if (this.members[i] !== other.members[i]) return false;
    }
    if (this.mode !== other.mode) return false;
    if (this.lacpRate !== other.lacpRate) return false;
    if (this.hashPolicy !== other.hashPolicy) return false;
    if (this.miiInterval !== other.miiInterval) return false;
    if (this.upDelay !== other.upDelay) return false;
    if (this.downDelay !== other.downDelay) return false;
    if (this.minLinks !== other.minLinks) return false;
    if (this.primary !== other.primary) return false;
    if (this.dhcp4 !== other.dhcp4) return false;
    if (this.dhcp6 !== other.dhcp6) return false;
    if (this.acceptRa !== other.acceptRa) return false;
    if (this.addresses.length !== other.addresses.length) return false;
    for (let i = 0; i < this.addresses.length; i++) {
      if (this.addresses[i] !== other.addresses[i]) return false;
    }
    if (this.gateway4 !== other.gateway4) return false;
    if (this.gateway6 !== other.gateway6) return false;
    if (this.mtu !== other.mtu) return false;
    return true;
  }
}

export function verifyBondConfig(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 24, 1);
    verifier.checkScalarField(tablePos, 26, 1);
    verifier.checkScalarField(tablePos, 28, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 34);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 36, 4);
  } finally {
    verifier.popDepth();
  }
}
